import React from "react";

import {
	Box,
	Typography
} from "@mui/material";

import { Redirect } from "react-router-dom";

import ZPlayLoader from "commons/zplay-loader";

import SubscribeService from "services/subscribe-service";
import AuthenticationService from "services/authentication-service";
import ProductService from "services/product-service";

import { UserProfileState } from "./models";

import { Trans } from "@lingui/macro";
import { ProfileTable } from "components/user-profile/profile-table/profile-table";
import { SubscriptionTable } from "components/user-profile/subscription-table/subscription-table";
import { BillingTable } from "components/user-profile/billing-table/billing-table";

export class UserProfile extends React.Component<{}, UserProfileState>
{
	constructor(props: any) {
		super(props);

		this.state = {
			isLoading: true,
			successLogin: false,
			subscription: null,
			product: null,
			user: AuthenticationService.getLocalCurrentUser(),
		};
	}

	componentDidMount() {
		SubscribeService.getSubscription(this.successGetSubscriptionCallback, this.errorGetSubscriptionCallback);
	}

	private successGetSubscriptionCallback = (data: any) => {

		this.setState(() => ({
			isLoading: false,
			subscription: data
		}));

		let productId = data.items.data[0].price.product;
		ProductService.getProduct(productId, this.successGetProductCallback, this.errorGetProductCallback);
	};

	private errorGetSubscriptionCallback = (err: any) => {
		this.setState(() => ({ isLoading: false }));
		console.log(err);
	};

	private successGetProductCallback = (data: any) => {

		this.setState(() => ({
			isLoading: true,
			product: data
		}));
	};

	private errorGetProductCallback = (err: any) => {
		this.setState(() => ({ isLoading: false }));
		console.log(err);
	};

	private deleteSubscription = () => {

		SubscribeService.deleteSubscription(this.successDelSubscriptionCallback, this.errorDelSubscriptionCallback)
	}

	private successDelSubscriptionCallback = (data: any) => {

		this.setState(() => ({
			isLoading: true,
			successLogin: true,
		}));
	};

	private errorDelSubscriptionCallback = (err: any) => {
		this.setState(() => ({ isLoading: false }));
		console.log(err);
	};

	render() {
		return (<>
			{this.state.successLogin && <Redirect to={"/"} />}
			<Box className={"h-catalog-title"} textAlign={"center"} marginBottom={8}>
				<Typography variant={"h1"}
					sx={{
						color: "#FFFFFF",
						fontWeight: "bold",
						textTransform: "uppercase"
					}}>
					<Trans id="up-page-title">Il mio profilo</Trans>
				</Typography>
			</Box>
			{this.state.isLoading && <Box>
				<ProfileTable user={this.state.user} />
				<SubscriptionTable user={this.state.user} subscription={this.state.subscription} product={this.state.product} deleteSubscription={this.deleteSubscription} />
				<BillingTable user={this.state.user} subscription={this.state.subscription} />
			</Box>}
			{!this.state.isLoading && <ZPlayLoader />}
		</>)
	}
}
